import { css, Theme } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const FooterStyle = {
  self: css`
    margin-top: 50px;
  `,

  wrapper: ({ colors }: Theme) => css`
    color: ${colors.orange[200]};
    max-width: 1480px;
    margin: 0 auto;
    ${media.xxl} {
      width: 100%;
      max-width: unset;
    }
  `,

  infoBlock: css`
    margin-bottom: 40px;
  `,

  shBlock: css`
    margin-bottom: 60px;
  `,

  aboutUsBlock: css`
    margin-bottom: 40px;
  `,

  supplierWrap: css`
    background-color: ${theme.colors.gray[850]};
    color: ${theme.colors.orange[200]};

    margin: 0 auto;
  `,
};
